import {
   PARTNER_REFERENCE_TITLE,
   transRefLabel,
   NO_TRANS_REFS,
   syncRefLabel,
   NO_SYNC_REFS,
   PARTNER,
} from 'common/strings';
import Panel from 'components/Panel';
import ReferenceItems from 'features/layout/CommonPage/panels/ReferencesPanel/ReferenceItems';
import React, {memo} from 'react';
import {useSynchronizationsRefs} from 'redux/synchronizations/hooks/useSynchronizationsRefs';
import {useTransactionsRefs} from 'redux/transactions/hooks/useTransactionsRefs';

// const NUM_REF_ROWS = 5;

type PartnerReferencesPanelProps = {
   id: string;
};
const PartnerReferencesPanel = ({id}: PartnerReferencesPanelProps) => {
   const transactions = useTransactionsRefs(id, 'partner');
   const synchronizations = useSynchronizationsRefs(id, 'partner');
   const transReferenceLabel = transRefLabel(PARTNER);
   const syncReferenceLabel = syncRefLabel(PARTNER);

   return (
      <Panel name={PARTNER_REFERENCE_TITLE}>
         <ReferenceItems name={transReferenceLabel} data={transactions} noData={NO_TRANS_REFS} />
         <ReferenceItems name={syncReferenceLabel} data={synchronizations} noData={NO_SYNC_REFS} />
      </Panel>
   );
};

export default memo(PartnerReferencesPanel);
